import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Spin,
  Descriptions,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../group/group.config";
import CustomButton from "../../../../../components/custom/CustomButton";
import cnt from "../../../../../services/definedConstant";
import styles from "../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const TransferFunds = (props) => {
  const { TextArea } = Input;
  const { Text, Title } = Typography;

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();

  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [toOfficeDetail, setToOfficeDetail] = useState(null);
  const [toClientDetail, setToClientDetail] = useState(null);
  const [toAccountTypeDetail, setToAccountTypeDetail] = useState(null);
  const [toAccountDetail, setToAccountDetail] = useState(null);
  const [toAccountData, setToAccountData] = useState([]);
  const [fromOfficeData, setFromOfficeData] = useState({});
  const [fromAccountTypeData, setFromAccountTypeData] = useState({});
  const [fromAccountData, setFromAccountData] = useState({});
  const [fromClientData, setFromClientData] = useState([]);
  const [toOfficeData, setToOfficeData] = useState([]);
  const [toAccountTypeData, setToAccountTypeData] = useState([]);
  const [toClientData, setToClientData] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);

  const getTemplate = () => {
    setIsLoading(true);
    const params = {
      fromAccountId: state.id,
      fromAccountType: 2,
    };
    const url = `${apiConfig.Accounttransfers}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;

        let tempFromAccountType = objList?.fromAccountType;
        let tempFromAccount = objList?.fromAccount;
        let tempfromOffice = objList?.fromOffice;
        let tempToOfficeOptions = [];
        let tempToAccountTypeOptions = [];

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setFromAccountTypeData(tempFromAccountType);
        setFromAccountData(tempFromAccount);
        setFromOfficeData(tempfromOffice);

        setToOfficeData(tempToOfficeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeToOFfice = (toOfficeParam) => {
    setToOfficeDetail(toOfficeParam);
    setIsLoading(true);
    const params = {
      fromAccountId: state.id,
      fromAccountType: 2,
      toOfficeId: toOfficeParam,
      toAccountId: toAccountDetail,
      toAccountType: toAccountTypeDetail,
      toClientId: toClientDetail,
    };
    const url = `${apiConfig.Accounttransfers}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;

        let tempToClientOptions = [];
        let tempToAccountTypeOptions = [];

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setToClientData(tempToClientOptions);
        setToAccountTypeData(tempToAccountTypeOptions);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeToClient = (toClientParam) => {
    setToClientDetail(toClientParam);
    setIsLoading(true);
    const params = {
      fromAccountId: state.id,
      fromAccountType: 2,
      toClientId: toClientParam,
      toOfficeId: toOfficeDetail,
      toAccountId: toAccountDetail,
      toAccountType: toAccountTypeDetail,
    };
    const url = `${apiConfig.Accounttransfers}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toAccountOptions.forEach((element) => {
          tempToAccountOptions.push({
            value: element.id,
            label: element?.productName
              ? `${element?.productName} - ${element?.accountNo}`
              : "-",
          });
        });

        setToAccountData(tempToAccountOptions);
        setToAccountTypeData(tempToAccountTypeOptions);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeToAccountType = (toAccountTypeParam) => {
    setToAccountTypeDetail(toAccountTypeParam);
    setIsLoading(true);
    const params = {
      fromAccountId: state.id,
      fromAccountType: 2,
      toAccountType: toAccountTypeParam,
      toClientId: toClientDetail,
      toOfficeId: toOfficeDetail,
      toAccountId: toAccountDetail,
    };
    const url = `${apiConfig.Accounttransfers}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;

        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toAccountOptions.forEach((element) => {
          tempToAccountOptions.push({
            value: element.id,
            label: element?.productName
              ? `${element?.productName} - ${element?.accountNo}`
              : "-",
          });
        });

        setToAccountTypeData(tempToAccountTypeOptions);
        setToAccountData(tempToAccountOptions);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeToAccount = (toAccountParam) => {
    setToAccountDetail(toAccountParam);
    setIsLoading(true);
    const params = {
      fromAccountId: state.id,
      fromAccountType: 2,
      toAccountId: toAccountParam,
      toAccountType: toAccountTypeDetail,
      toClientId: toClientDetail,
      toOfficeId: toOfficeDetail,
    };
    const url = `${apiConfig.Accounttransfers}/template`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;

        let tempToAccountTypeOptions = [];

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const items = [
    {
      key: "1",
      label: labelConfig.applicant,
      children: fromAccountData?.clientName,
    },
    {
      key: "2",
      label: labelConfig.fromAccount,
      children: fromAccountData
        ? `${fromAccountData?.productName} -  ${fromAccountData?.accountNo}`
        : "-",
    },
    {
      key: "3",
      label: labelConfig.currency,
      children: fromAccountData?.currency?.name,
    },
    {
      key: "4",
      label: labelConfig.branch,
      children: fromOfficeData?.name,
    },
    {
      key: "5",
      label: labelConfig.fromAccountType,
      children: fromAccountTypeData?.value,
      span: 3,
    },
  ];

  const onSubmit = (formValues) => {
    formValues.transferDate = BOM.DateTime(
      formValues.transferDate,
      "only-date"
    );
    formValues.fromAccountId = fromAccountData.id;
    formValues.fromAccountType = fromAccountTypeData.id;
    formValues.fromClientId = fromAccountData.clientId;
    formValues.fromOfficeId = fromOfficeData.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.locale = "en";

    const body = {
      ...formValues,
      method: "POST",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Accounttransfers,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.savingsAccountFundTransferdMsg);
          navigate("/detail-recurring-deposit-account", { state: state });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-recurring-deposit-account", { state: state });
          setIsLoading(false);
        },
      }
    );
  };

  function onCancel() {
    navigate("/detail-recurring-deposit-account", { state: state });
  }
  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.accountTransfers}
        pageItems={staticConfig.accountTransferBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            useForm={useForm}
            layout="vertical"
            // onFinish={handleAddressSave}
            onFinish={onSubmit}
          >
            {/* <Row> */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.transferedFromDetails}
              </Title>
            </Divider>
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
            {/* </Row> */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.transferringTo}
              </Title>
            </Divider>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name={"toOfficeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.branch,
                      "select"
                    )}
                    options={toOfficeData}
                    onChange={onChangeToOFfice}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.customer}
                  name={"toClientId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.customer),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.customer,
                      "select"
                    )}
                    options={toClientData}
                    onChange={onChangeToClient}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountType}
                  name={"toAccountType"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.accountType),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountType,
                      "select"
                    )}
                    options={toAccountTypeData}
                    onChange={onChangeToAccountType}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.account}
                  name={"toAccountId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.account),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.account,
                      "select"
                    )}
                    options={toAccountData}
                    onChange={onChangeToAccount}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.amount}
                  name={"transferAmount"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.amount),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name={"transferDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 35 }}
                    disabledDate={BOM.DisabledAfterCurrentDate}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionID}
                  name={"transactionUniqueId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionID),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.transactionID
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Description"} name={"transferDescription"}>
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg("Description")}
                    autoSize={{
                      minRows: 2,
                      maxRows: 6,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default TransferFunds;
